module.exports = __webpack_public_path__ + "static/img/3.606197d7.png";